import { CurrentOrder } from 'src/app/shared/models/current-order.model';
import { CurrentOrderService } from 'src/app/shared/services/current-order.service';

export abstract class BaseComponent {

  get currentOrder(): CurrentOrder {
    if (!this.currentOrderService.currentOrder) {
      this.currentOrderService.currentOrder = {
        OrderCode: '',
        OrderName: '',
        AccountCode: '',
        OrderingServiceCode: '',
        QuotationCode: '',
        ContractCode: '',
        ReceivingLabCode: '',
        SampleServiceCode: '',
        samples: [],
        additionalFields: [],
        attachDocuments: []
      };
    }
    return this.currentOrderService.currentOrder;
  }
  constructor(protected currentOrderService: CurrentOrderService) {
  }
}
